import { Injectable } from '@angular/core';

import { map, catchError, withLatestFrom, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';

/* NgRx */
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FiltroApiActions, FiltroPageActions } from './actions';
import { FiltroService } from '../filtro.service';
import { State, getSelectedPeriodos } from './filtro.selector';
import { Store } from '@ngrx/store';


@Injectable()
export class FiltroEffects {

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private service: FiltroService
  ) { }

  loadMaterias$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FiltroPageActions.loadMaterias),
      concatMap(() => this.service.getMaterias().pipe(
        map(materias => FiltroApiActions.loadMateriasSuccess({ materias: materias })),
        catchError(error => of(FiltroApiActions.loadMateriasFailure({ error }))),
      ))
    );
  });

  loadMateriasMcp$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FiltroPageActions.loadMateriasMcp),
      concatMap(() => this.service.getMateriasMcp().pipe(
        map(materias => FiltroApiActions.loadMateriasMcpSuccess({ materiasMcp: materias})),
        catchError(error => of(FiltroApiActions.loadMateriasMcpFailure({ error }))),
      ))
    );
  });

  loadCursos$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FiltroPageActions.loadCursos),
      concatMap((load) => this.service.getCursosParent(load.soloActivos).pipe(
        map(cursos => FiltroApiActions.loadCursosSuccess({ cursos: cursos })),
        catchError(error => of(FiltroApiActions.loadCursosFailure({ error }))),
      ))
    );
  });

  loadPeriodos$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FiltroPageActions.loadPeriodos),
      concatMap(action => this.service.getPeriodosParent(action.includeNonActive).pipe(
        map(periodos => FiltroApiActions.loadPeriodosSuccess({ periodos: periodos })),
        catchError(error => of(FiltroApiActions.loadPeriodosFailure({ error }))),
      ))
    );
  });

  loadSesiones$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FiltroPageActions.loadSesiones, FiltroPageActions.selectedPeriodos),
      withLatestFrom(this.store.select(getSelectedPeriodos)),
      concatMap(([, periodos]) => this.service.getSesiones({ ids: periodos.toString() }).pipe(
        map(sesiones => FiltroApiActions.loadSesionesSuccess({ sesiones: sesiones })),
        catchError(error => of(FiltroApiActions.loadSesionesFailure({ error }))),
      ))
    );
  });

}
